
import { Swiper, Navigation } from "swiper";
import ArticleHotBeautyCard from "./ArticleHotBeautyCard.vue";
export default {
    props: {
        article_data: Array,
    },
    data() {
        return {
            swiper: '',
            pa_count: 1
        };
    },
    computed: {
        window_width() {
            return this.$store.state.index_tab.window_width;
        }
    },
    mounted() {
        Swiper.use([Navigation]);
        this.swiper = new Swiper(".hot-index-swiper", {
            direction: "horizontal",
            observer: true,
            breakpoints: {
                769: {
                    slidesPerView: 2.7,
                    spaceBetween: 16,
                    slidesOffsetBefore: 70,
                }
            },
            slidesPerView: 1.2,
            spaceBetween: 8,
            modules: [Navigation],
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            }
        });
        this.swiper.on('slideChange', () => {
            let ref_name = 'ref_' + this.swiper.activeIndex
            this.$refs[ref_name][0].paFunction();
        });
        this.$refs.ref_0[0].paFunction();
        
    },
    components: { ArticleHotBeautyCard }
}
